// The bundled JSPlugin 3.0 SDK keeps document listeners and decoder workers
// alive after JS_Stop. Its destructor must run after the stream has stopped.
const pendingCleanup = new Set<Promise<void>>();
const cleanupByPlugin = new WeakMap<object, Promise<void>>();

export const destroyEZOPENPlugin = (plugin: any): Promise<void> => {
  const existing = cleanupByPlugin.get(plugin);
  if (existing) return existing;

  const cleanup = (async () => {
    try {
      await plugin.JS_Stop?.(0);
    } catch (error) {
      console.warn('Failed to stop EZOPEN stream during cleanup:', error);
    } finally {
      try {
        // JS_DestroyPlugin delegates to JS_DestroyWorker in the bundled SDK.
        const destroy = plugin.JS_DestroyPlugin ?? plugin.JS_DestroyWorker ?? plugin.JS_Destroy;
        await destroy?.call(plugin);
      } catch (error) {
        console.warn('Failed to destroy EZOPEN plugin:', error);
      }
    }
  })();

  cleanupByPlugin.set(plugin, cleanup);
  pendingCleanup.add(cleanup);
  void cleanup.then(() => pendingCleanup.delete(cleanup));
  return cleanup;
};

export const waitForEZOPENCleanup = async (): Promise<void> => {
  while (pendingCleanup.size > 0) {
    await Promise.all(Array.from(pendingCleanup));
  }
};
